export const BASE_UNDERLYING_LOGO_URL = `${process?.env?.NEXT_PUBLIC_IMGIX_URL}/${process?.env?.NEXT_PUBLIC_CLOUD_BLOB_ENVIRONMENT_SHORTNAME}/images/underlying-logos`;
export const UNDERLYING_FALLBACK_LOGO_URL = `${BASE_UNDERLYING_LOGO_URL}/000000000000.png`;
